import { getFormValues } from 'redux-form';
import { createSelector } from 'reselect';

import { NAME } from './constants';

export const getModel = (state) => state[NAME];

export const getInitialValues = createSelector(
    getModel,
    (model) => model.initialValues,
);

export const getValues = createSelector(
    (state) => getFormValues(`${NAME}/form`)(state),
    (values) => values || {},
);

export const getInitialFilterValues = createSelector(
    getModel,
    (model) => model.initialFilterValues,
);

export const getFilterValues = createSelector(
    (state) => getFormValues(`${NAME}/filter-form`)(state),
    (values) => values || {},
);

export const getAgents = createSelector(getModel, (model) => model.agents);

export const getAgentsData = createSelector(getAgents, (model) => model.data);

export const getCompanyDetailModel = createSelector(
    getModel,
    (model) => model.companyDetail,
);

export const getIsFetchingCompanyDetail = createSelector(
    getCompanyDetailModel,
    (companyDetail) => companyDetail.isFetching,
);

export const getCompanyDetailData = createSelector(
    getCompanyDetailModel,
    (companyDetail) => companyDetail.data || {},
);

export const getCompanyDetailErrors = createSelector(
    getCompanyDetailModel,
    (companyDetail) => companyDetail.errors,
);

export const getSave = createSelector(getModel, (model) => model.save);

export const getIsSaving = createSelector(getSave, (save) => save.isSaving);

export const getDataSave = createSelector(getSave, (save) => save.data);

export const getErrorsSave = createSelector(getSave, (save) => save.errors);

export const getProjectsCounters = createSelector(
    getModel,
    (model) => model.projectsCounters,
);

export const getProjectsCountersData = createSelector(
    getProjectsCounters,
    (model) => model.data,
);

export const getIsFetchingProjectsCounters = createSelector(
    getProjectsCounters,
    (model) => model.isFetching,
);

export const getProjectsCountersErrors = createSelector(
    getProjectsCounters,
    (model) => model.error,
);

export const getProposalsTotals = createSelector(
    getModel,
    (model) => model.proposalsTotals,
);

export const getProposalsTotalsData = createSelector(
    getProposalsTotals,
    (model) => model.data,
);

export const getIsFetchingProposalsTotals = createSelector(
    getProposalsTotals,
    (model) => model.isFetching,
);

export const getProposalsTotalsErrors = createSelector(
    getProposalsTotals,
    (model) => model.error,
);
